import { FC } from 'react';

import {
  FeatureFlags,
  LoginSwitchPage,
  NativeLoginPage,
} from '@app/components';
import { FEATURE } from '@app/constants';

export const LoginPage: FC = () => (
  <FeatureFlags
    flagsToMatch={[{ name: FEATURE.consortiaLoginFlow }]}
    renderOn={() => <LoginSwitchPage />}
    renderOff={() => <NativeLoginPage />}
  />
);
